import ColorPicker from './ColorPicker';

export default ColorPicker;


// WEBPACK FOOTER //
// ./src/components/Color/index.js